import English from "./en";
import French from "./fr";

const LangStrings = {
	en: English,
	fr: French,
};

 export default LangStrings
